import { LocaleString } from '../utilization/Contracts'
import { ProjectStatus, ProjectType } from './Contracts'

export const PROJECT_STATUS: Record<ProjectStatus, LocaleString> = {
  IN_PROGRESS: {
    en: 'In progress',
    sv: 'Pågår'
  },
  NOT_STARTED: {
    en: 'Not started',
    sv: 'Ej påbörjad'
  },
  PLANNED: {
    en: 'Planned',
    sv: 'Planerad'
  },
  COMPLETED: {
    en: 'Completed',
    sv: 'Avslutad'
  },
  UNKNOWN: {
    en: 'Unknown',
    sv: 'Okänd'
  },
  ON_HOLD: {
    en: 'On hold',
    sv: 'Pausad'
  }
}

export const PROJECT_TYPE: Record<ProjectType, LocaleString> = {
  ENERGY: {
    en: 'Energy project',
    sv: 'Energiprojekt'
  },
  TENANT_ADAPTATION: {
    en: 'Tenant adaptation',
    sv: 'Hyresgästanpassning'
  },
  INVESTMENT: {
    en: 'Investment project',
    sv: 'Investeringsprojekt'
  },
  MAINTENANCE: {
    en: 'Maintenance project',
    sv: 'Underhållsprojekt'
  },
  MISCELLANEOUS: {
    en: 'Miscellaneous',
    sv: 'Blandprojekt'
  },
  UNKNOWN: {
    en: 'Unknown',
    sv: 'Okänd'
  },
  DEVELOPMENT: {
    en: 'Development',
    sv: 'Exploateringsprojekt'
  },
  NEW_CONSTRUCTION: {
    en: 'New construction project',
    sv: 'Nybyggnadsprojekt'
  },
  ADMINISTRATIVE: {
    en: 'Administrative',
    sv: 'Administrativt'
  },
  BUSINESS_INVESTIGATION: {
    en: 'Business investigation',
    sv: 'Affärsutredningsprojekt'
  },
  STRATEGIC_INVESTIGATION: {
    en: 'Strategic investigation',
    sv: 'Strategiska utredningsprojekt'
  }
}

export const BADGE_COLORS: Record<ProjectStatus, string> = {
  NOT_STARTED: '#FFD6E7',
  PLANNED: '#EFDBFF',
  COMPLETED: '#C2F3EE',
  UNKNOWN: '#E0E0E0',
  IN_PROGRESS: '#BAE7FF',
  ON_HOLD: '#FFD6E7'
}
